import HttpClient from "../utils/http-client";

export class TrekService extends HttpClient {
  async getCareers(orgCode) {
    const url = "/careers";
    return this.http.get(url, { params: { org_code: orgCode } });
  }

  async upsertOrganizationCareers(orgCode, payload) {
    return await this.http.post(`/organizations/${orgCode}/careers`, payload);
  }

  async getOrganizationMSA(orgCode) {
    return await this.http.get(`/organizations/${orgCode}/msa`);
  }

  async updateOrganizationMSA(orgCode, payload) {
    return await this.http.put(`/organizations/${orgCode}/msa`, payload);
  }

  async getAllMSA() {
    return await this.http.get(`/msas`);
  }

  async getAdvisorRoles() {
    return await this.http.get(`/advisor-roles`);
  }

  async getOrganizationSettings(orgCode) {
    return await this.http.get(`/organizations/${orgCode}/settings`);
  }

  async updateOrganizationSettings(orgCode, payload) {
    return await this.http.put(`/organizations/${orgCode}/settings`, payload);
  }
}
